import React from 'react';
import { useTariffAssignments } from './hooks';
import { AssignmentTag, ChipLead, ChipRow, PanelLabel, PanelLine, PanelNote } from './blocks';

const AssignmentStatus = ({ tags, loading, error }) => {
    if (tags.length) {
        return (
            <ChipRow role="list" aria-label="Assigned to">
                {tags.map((tag) => (
                    <AssignmentTag key={tag.key} role="listitem">
                        <ChipLead>{tag.role}:</ChipLead> {tag.name}
                    </AssignmentTag>
                ))}
            </ChipRow>
        );
    }
    if (loading) return <PanelNote>Loading…</PanelNote>;
    if (error) return <PanelNote>Couldn't load assignments.</PanelNote>;
    return <PanelNote>Not assigned</PanelNote>;
};

const TariffAssignments = ({ tariffId }) => {
    const { tags, loading, error } = useTariffAssignments(tariffId);

    return (
        <PanelLine>
            <PanelLabel>ASSIGNED TO:</PanelLabel>
            <AssignmentStatus tags={tags} loading={loading} error={error} />
        </PanelLine>
    );
};

export default TariffAssignments;
